import { toDateStr, formatDisplayDate } from '../../utils';
import s from '../../styles/dashboard.module.css';

// Prev/next day navigation with a hidden native date picker.
export function DateNav({ selectedDate, onChange }) {
  const today   = toDateStr(new Date());
  const isToday = selectedDate === today;
  function shift(days) { const d = new Date(selectedDate + 'T12:00:00'); d.setDate(d.getDate() + days); onChange(toDateStr(d)); }
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      <button className={s.dateNavBtn} onClick={() => shift(-1)}>‹</button>
      <div style={{ position: 'relative' }}>
        <div className={`${s.dateNavDisplay} ${isToday ? s.dateNavDisplayToday : s.dateNavDisplayOther}`}
             onClick={() => document.getElementById('date-picker-input').showPicker?.() || document.getElementById('date-picker-input').focus()}>
          {formatDisplayDate(selectedDate)}
        </div>
        <input id="date-picker-input" type="date" value={selectedDate} onChange={e => e.target.value && onChange(e.target.value)}
               className={s.dateNavHiddenInput} />
      </div>
      <button className={s.dateNavBtn} onClick={() => shift(1)}>›</button>
      {!isToday && <button onClick={() => onChange(today)} className={s.dateNavTodayBtn}>Today</button>}
    </div>
  );
}
